export default __webpack_public_path__ + "static/media/aquarium.2e3efa47.png";